<script setup lang="ts">
interface Props {
    content: string | number;
}
defineProps<Props>();
</script>

<template>
    <div class="relative">
        <slot />
        <div class="absolute -right-2 -top-2 bg-red-500 rounded-full w-5 h-5 text-white text-xs font-semibold flex justify-center items-center">{{ content }}</div>
    </div>
</template>
